import {Storage} from "@/services/Storage";
import axios from "axios";
import router from "@/router";
import TimeManager from "@/services/TimeManager";
import store from "@/store";

export default {
    name: 'billing',
    state: {
        daysToExpire: 30
    },
    getters: {
        getDaysToExpire: (state) => state.daysToExpire,
    },
    mutations: {
        setDaysToExpire: (state, data) => state.daysToExpire = data,
    },
    actions: {
        getExpiryDateByCustomerID: async (context) => {
            let storeID = await Storage.getRegistrationDetails();
            if (!storeID) return;
            return axios.get(subscriptionApi + `adminCustomerPanel/getExpiryDate?customer=` + storeID.id)
                .then(({data}) => {
                    let days = TimeManager.getDateDiff(TimeManager.getNow(), data)
                    context.commit(`setDaysToExpire`, days);
                    if (days <= 0) {
                        return router.push({ name: 'validation' });
                    }
                }).catch(err => {
                    errorHandler.tomcatError(err);
                    router.push({ name: 'login' });
                    throw err;
                })
        },

        getCustomerBalance: async () => {
            let customerID = await Storage.getCurrentStoreID();
            if (!customerID) return;
            return axios.get(subscriptionApi+ `adminCustomerPanel/getBalance?customer=` + customerID)
                .then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },

        hasOverdueCount: async (context) => {
            let customerID = await Storage.getCurrentStoreID();
            if (!customerID) return;
            return axios.get(subscriptionApi+`adminCustomerPanel/hasOverdueCount?customer=` + customerID)
                .then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },

        getDueInvoices: async () => {
            let storeID = await Storage.getRegistrationDetails();
            if (!storeID) return;
            return axios.get(subscriptionApi+ `adminCustomerPanel/getDueInvoice?customer=` + storeID.id)
                .then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },

        getActiveStores: async () => {
            let customerID = await Storage.getCurrentStoreID();
            if (!customerID) return;
            return axios.get(subscriptionApi + `adminCustomerPanel/getActiveStores?customer=` + customerID)
                .then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },

        getCustomerQuotes: async (context) => {
            let customerID = await Storage.getCurrentStoreID();
            if (!customerID) return;
            return axios.get(subscriptionApi+`adminCustomerPanel/getQuotes?customer=` + customerID)
                .then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },
        makeKazangLicensePayment: async (context, payload) => {
            let invoiceReference = payload.invoiceReference;
            return axios.post(kazangSubscriptionApi + `paymentGateWay/makeAndProcessPayment`, payload, {timeout: 1000 * 2 * 60})
                .then(() => {
                    return axios.get(subscriptionApiGET, {
                        params: {
                            route: `paymentCompleted/kazangProcess/${invoiceReference}`
                        }
                    }).then(() => context.dispatch(`getExpiryDateByCustomerID`)).catch(err => {
                        throw new Error(err.response)
                    })
                }).catch(err => errorHandler.tomcatError(err));

        },

        makeVCDLicensePayment: async (context, invoiceReference) => {
            return axios.get(subscriptionApi+`paymentCompleted/kazangProcessVCD/${invoiceReference}`)
                .then(() => context.dispatch(`getExpiryDateByCustomerID`)).catch(err => errorHandler.tomcatError(err));
        },

    }
}
